import React, { ReactNode } from 'react';

// Components
import Navbar from '../Navbar';
import MobileNavbar from '../MobileNavbar';
import { ButtonLink } from '../common';
import Footer from '../Footer';

// Hooks
import { useVisitId } from '../../hooks/useVisitId';
import useContextToken from '../../hooks/useContextToken';

// Helpers
import { getBuyflowLink } from '../../utils/helpers';

import './Layout.scss';

interface ILayoutProps {
  className?: string;
  header?: ReactNode;
  children?: ReactNode;
  bottomBanner?: ReactNode;
  hasGradient?: boolean;
  isXumoPage?: boolean;
}
const Layout = ({
  className = 'page',
  header,
  children,
  bottomBanner,
  hasGradient = true,
  isXumoPage = false,
}: ILayoutProps) => {
  const visitId = useVisitId();
  const { contextToken } = useContextToken();

  const buyflowLink = getBuyflowLink(
    'https://www.spectrum.com/cable-tv/plans?cmp=sspp_sod_gm_topnav_unauth_050523',
    'https://www.spectrum.net/change?cid=sspp_sod_gm_topnav_auth_050523'
  );

  return (
    <div className={`kite-theme kite-theme--mode-dark ${hasGradient ? 'gradient' : ''}`}>
      <header className="site-header">
        <ButtonLink
          path="#main-content"
          type="secondary"
          className="skip-to-content"
          tealiumConfig={{
            dataLinkName: 'Skip To Main Content',
            dataLinkType: 'screen-reader-only',
          }}
        >
          Skip to main content
        </ButtonLink>
        {!isXumoPage && (
          <Navbar
            hasGradient={hasGradient}
            visitId={visitId}
            buyflowLink={buyflowLink}
            contextToken={contextToken}
          />
        )}
        {!isXumoPage && <MobileNavbar />}
      </header>
      <div className="container" id="main-content">
        {header}
        <main className={className}>{children}</main>
        {bottomBanner}
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
